import R from 'app/assets/R'
import { IRefModal } from 'app/components/common/ModalComponent'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import { notificationController } from 'app/controllers/notification-controller'
import { useUpdateSchool } from 'app/react-query/hook/school'
import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { IPayloadUpdateSchool, IProps } from './type'

export const useHook = ({ school }: IProps) => {
  const { t } = useTranslation()
  const [form] = BaseForm.useForm<IPayloadUpdateSchool>()
  const modalRef = useRef<IRefModal>({})

  const { mutateAsync: mutateAsyncUpdate, isLoading } = useUpdateSchool()

  useEffect(() => {
    form?.setFieldsValue({
      name: school?.name,
      description: school?.description,
      code: school.code,
    })
  }, [school])

  const handleSubmit = async (values: IPayloadUpdateSchool) => {
    const newData: IPayloadUpdateSchool = {
      id: school?.id,
      name: values?.name,
      description: values?.description,
      code: values?.code,
    }

    const res = await mutateAsyncUpdate?.(newData)
    if (res) {
      modalRef?.current?.hide?.()
      form?.resetFields()
      notificationController.success({
        message: t(R.strings.success),
      })
    }
  }

  return {
    form,
    modalRef,
    handleSubmit,
    isLoading,
  }
}
